<template>
  <div
    class="modal fade wrap"
    :ref="id"
    tabindex="-1"
    :aria-labelledby="`${id}-label`"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center py-5">
          <button
            class="btn-close position-absolute end-0 top-0 mt-2 me-2"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="pb-4">
            <div class="mb-3">
              <slot name="icon" />
            </div>
            <h4
              class="modal-title text-center font-header mb-3"
              v-if="title"
              :id="`${id}-label`"
            >
              {{ title }}
            </h4>
            <checkmark v-if="icon" class="mb-4"></checkmark>
            <slot></slot>
          </div>

          <button
            class="btn btn-primary rounded-pill text-white px-4"
            v-if="confirmLabel"
            data-bs-dismiss="modal"
            type="button"
            @click="$emit('confirm')"
            :disabled="confirmDisabled"
          >
            {{ confirmLabel }}
          </button>

          <button
            class="btn bg-black bg-opacity-50 rounded-pill text-white px-4"
            v-if="cancelLabel"
            data-bs-dismiss="modal"
            type="button"
            @click="$emit('close')"
          >
            {{ cancelLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// let Modal;
// if (process.client) Modal = require("bootstrap/js/dist/modal.js");

import { Modal } from "bootstrap";
import Checkmark from "./Checkmark.vue";

export default {
  name: "BootstrapModal",
  components: { Checkmark },
  props: {
    title: {
      type: String,
      default: "",
    },

    confirmLabel: {
      type: String,
      default: "",
    },

    confirmDisabled: {
      type: Boolean,
      default: false,
    },

    cancelLabel: {
      type: String,
      default: "",
    },

    id: {
      type: String,
      required: true,
    },

    open: {
      type: Boolean,
      required: true,
    },

    icon: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    // const myModal = new Modal(document.querySelector("#sadasdas"));
    // myModal.show();
  },

  watch: {
    open(val) {
      if (!val) return;
      const myModal = new Modal(this.$refs[this.id]);
      myModal.show();
    },
  },

  mounted() {
    this.$refs[this.id].addEventListener("hidden.bs.modal", () => {
      this.$emit("close");
    });
  },
};
</script>
